export default "__VITE_ASSET__BcvrImBW__"